import { render } from "./CommentUserChip.vue?vue&type=template&id=23703c21&scoped=true&ts=true"
import script from "./CommentUserChip.vue?vue&type=script&lang=ts"
export * from "./CommentUserChip.vue?vue&type=script&lang=ts"

import "./CommentUserChip.vue?vue&type=style&index=0&id=23703c21&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23703c21"]])

export default __exports__